import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PackagePlus } from "lucide-react";
import { api } from "../../lib/api";
import { ddmmyyyy, num } from "../../lib/format";
import { LRChip } from "../grn/GRNCard";
import { useAuth } from "../../context/AuthContext";

export const POGrns = ({ po, testid }) => {
  const { can } = useAuth();
  const [grns, setGrns] = useState(null);
  useEffect(() => {
    api.get("/grns", { params: { po_id: po.id } }).then((r) => setGrns(r.data)).catch(() => setGrns([]));
  }, [po.id, po.updated_at]);

  return (
    <div className="space-y-2" data-testid={`${testid}-grns`}>
      <h3 className="mono-label text-muted-foreground">Goods received</h3>
      <div className="rounded-lg bg-card p-3 text-sm">
        {po.items.map((it) => (
          <div key={it.id} className="flex justify-between gap-3 py-1">
            <span className="min-w-0 truncate">{it.description}</span>
            <span className="mono shrink-0 text-xs">
              {num(it.received || 0)}/{num(it.qty)} {it.uom}
              {(it.received || 0) < it.qty && <span className="text-muted-foreground"> · bal {num(it.qty - (it.received || 0))}</span>}
            </span>
          </div>
        ))}
        {po.fully_received && <p className="mt-1 text-xs font-bold text-brand" data-testid={`${testid}-fully-received`}>Fully received</p>}
      </div>
      {grns?.map((g) => (
        <Link key={g.id} to="/grns" state={{ open: g.id }} className="flex items-center justify-between gap-2 rounded-lg border px-3 py-2 text-sm" data-testid={`${testid}-grn-${g.grn_no}`}>
          <span className="mono font-semibold">{g.grn_no}</span>
          <span className="text-xs text-muted-foreground">{ddmmyyyy(g.grn_date)}</span>
          <LRChip status={g.lr_status} />
        </Link>
      ))}
      {po.status === "Accepted" && !po.fully_received && can("grn_write") && (
        <Link to={`/pos/${po.id}/grn/new`} className="btn btn-outline w-full" data-testid={`${testid}-new-grn-btn`}>
          <PackagePlus size={18} /> Receive goods (GRN)
        </Link>
      )}
    </div>
  );
};
